export const AUTH_SESSION_INVALIDATED_EVENT = 'cosellus:auth-session-invalidated';

export type AuthSessionInvalidationDetail = {
  reason: string;
  endpoint?: string;
  status?: number;
};

export const emitAuthSessionInvalidated = (
  detail: AuthSessionInvalidationDetail,
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<AuthSessionInvalidationDetail>(AUTH_SESSION_INVALIDATED_EVENT, {
      detail,
    }),
  );
};
